import { getError as getTokenError } from 'lib/core/data/customer/token/selectors'
import { Slice } from './types'

export const getSlice = (state: any): Slice => {
  return state.auth.login
}

export const getError = getTokenError
